import { gql } from "@apollo/client";

export const RESOLVE_AUDIT_FINDING = gql`
  mutation ResolveAuditFinding($id: ID!, $status: String!, $note: String) {
    resolveAuditFinding(id: $id, status: $status, note: $note) {
      finding {
        id
        status
        resolutionNote
        resolvedAt
      }
      errors
    }
  }
`;

export const COPY_AUDIT_REPORT = gql`
  mutation CopyAuditReport(
    $filePath: String
    $pending: Boolean
    $status: String
    $auditor: String
    $severity: String
    $category: String
    $subject: String
    $grade: Int
    $skill: String
  ) {
    copyAuditReport(
      filePath: $filePath
      pending: $pending
      status: $status
      auditor: $auditor
      severity: $severity
      category: $category
      subject: $subject
      grade: $grade
      skill: $skill
    ) {
      report
      errors
    }
  }
`;
